module.exports = __webpack_public_path__ + "img/social-service.b824e96d.gif";